import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ReactComponent as DownTriangle } from "../Images/down_triangle_blue.svg";
import { ReactComponent as IconCrossRound } from "../Images/icon_cross_round.svg";
import { ReactComponent as IconInfo } from "../Images/icon_info.svg";
import { ReactComponent as UpTriangle } from "../Images/up_triangle_red.svg";
import LayoutModal from "../Layout/LayoutModal";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";
import { postJson } from "../Utils/apiUtils";
import { cCode_to_nation } from "../Utils/numberUtils";

const RankingsBox = ({
  title,
  infotext,
  contestType,
  contestTitle,
  contestPeriod,
  ourcontestType,
  handleClickX,
  id,
}) => {
  const navigate = useNavigate();
  const offset = 20;
  const isOurContest = contestType === "우리끼리 대회";
  const isDepartmentBattle = contestType === "부서별 대항전";
  const _ourContestType = isOurContest
    ? ourcontestType === 0
      ? "만보기(개인전)"
      : "만보기(팀전)"
    : "";
  const isTeamRankingLayout =
    _ourContestType === "만보기(팀전)" || isDepartmentBattle;

  const [list, setList] = useState([]);
  const [teamRanking_type, setTeamRanking_type] = useState(0);
  const [teamId, setTeamId] = useState(null);
  const [ranking, setRanking] = useState(0);
  const [teamName, setTeamName] = useState("");

  const [clickMemberRankings, setClickMemberRankings] = useState(false);

  const getRankingList = async () => {
    try {
      let currentPage = 1;
      let body;
      let res;
      let newList = [];

      if (contestType === "우리끼리 대회") {
        if (_ourContestType === "만보기(개인전)") {
          body = { page: currentPage, offset, meetWeId: id };
          do {
            res = await postJson("/dashboard/meetWe/getRankingList", body, navigate);
            newList = [...newList, ...res.data.rows];
            currentPage += 1;
            body.page = currentPage;
          } while (res.code === 200 && res.data.isNext === 1);
        } else if (_ourContestType === "만보기(팀전)") {
          body = {
            page: currentPage,
            offset,
            meetWeId: id,
            type: teamRanking_type,
          };
          do {
            res = await postJson(
              "/dashboard/meetWe/getRankingListTeam",
              body,
              navigate
            );
            newList = [...newList, ...res.data.rows];
            currentPage += 1;
            body.page = currentPage;
          } while (res.code === 200 && res.data.isNext === 1);
        }
      } else if (contestType === "이벤트 대회") {
        body = {
          page: currentPage,
          offset,
          seasonId: id,
        };
        do {
          res = await postJson("/dashboard/user/getRankingList", body, navigate);
          newList = [...newList, ...res.data.rows];
          currentPage += 1;
          body.page = currentPage;
        } while (res.code === 200 && res.data.isNext === 1);
      } else if (contestType === "부서별 대항전") {
        body = {
          page: currentPage,
          offset,
          seasonDepartmentId: id,
        };
        do {
          res = await postJson(
            "/dashboard/departmentBattle/getRankingList",
            body,
            navigate
          );
          newList = [...newList, ...res.data.rows];
          currentPage += 1;
          body.page = currentPage;
        } while (res.code === 200 && res.data.isNext === 1);
      }
      setList(newList);
    } catch (error) {
      console.log("랭킹 리스트(모달) 가져오기 중 에러");
      throw error;
    }
  };

  const onClickMemberRankings = (id, ranking, teamName) => {
    setTeamId(id);
    setRanking(ranking);
    setTeamName(teamName);
    setClickMemberRankings(true);
  };

  useEffect(() => {
    getRankingList();
  }, [teamRanking_type]);

  return (
    <div>
      {clickMemberRankings && (
        <MemberRanking
          handleClickX={() => setClickMemberRankings(false)}
          ranking={ranking}
          meetWeTeamId={teamId}
          teamName={teamName}
        />
      )}
      <Box type={_ourContestType} $isDepartmentBattle={isDepartmentBattle}>
        <div className="hrz-wrapper center">
          <p className="bold-text" style={{ fontSize: "24px" }}>
            {title}
          </p>
        </div>
        <div className="hrz-wrapper" style={{ marginTop: "-32px" }}>
          <div style={{ marginLeft: "auto", cursor: "pointer" }}>
            <IconCrossRound onClick={handleClickX} />
          </div>
        </div>

        {!isDepartmentBattle && infotext !== "" && (
          <div className="hrz-wrapper" style={{ marginTop: "20px" }}>
            <IconInfo fill="#888888" />
            <p
              style={{ fontSize: "15px", color: "#888888", marginLeft: "4px" }}
            >
              {infotext}
            </p>
          </div>
        )}

        <div className="grayBox">
          <p className="medium-text" style={{ fontSize: "14px" }}>
            {contestType}
          </p>
          <p
            className="bold-text"
            style={{ fontSize: "18px", color: "#000000", marginTop: "4px" }}
          >
            {contestTitle}
          </p>
          {contestPeriod && (
            <p style={{ marginTop: "4px", color: "#555555" }}>{contestPeriod}</p>
          )}
          {isOurContest && ourcontestType !== "" && (
            <p style={{ marginTop: "4px" }}>{_ourContestType}</p>
          )}
        </div>

        {isOurContest && _ourContestType === "만보기(팀전)" && (
          <div style={{ display: "flex", gap: "8px", marginBottom: "20px" }}>
            <TypeClickButton
              $isClicked={teamRanking_type === 0}
              onClick={() => setTeamRanking_type(0)}
            >
              팀별 누적 랭킹
            </TypeClickButton>
            <TypeClickButton
              $isClicked={teamRanking_type === 1}
              onClick={() => setTeamRanking_type(1)}
            >
              팀별 평균 랭킹
            </TypeClickButton>
          </div>
        )}

        <div className="listLabel">
          <p className="center">랭킹</p>
          <p className="leftalign">추이</p>
          <p className="leftalign">
            {isDepartmentBattle
              ? "부서명"
              : isTeamRankingLayout
              ? "팀 이름"
              : "닉네임"}
          </p>
          <p className="leftalign">
            {isDepartmentBattle ? "부서별 목표 걸음 수" : "누적 걸음 수"}
          </p>
          <p className="leftalign">
            {isDepartmentBattle
              ? "달성률"
              : isTeamRankingLayout
              ? "팀 인원수"
              : "국가"}
          </p>
        </div>
        <ScrollArea
          type={isTeamRankingLayout ? "만보기(팀전)" : _ourContestType}
          $isDepartmentBattle={isDepartmentBattle}
        >
          {list.length === 0 ? (
            <div className="center" style={{ width: "100%", height: "100%" }}>
              <p style={{ fontSize: "15px", color: "#888888" }}>
                아직 참여 기록이 없습니다.
              </p>
            </div>
          ) : (
            list.map((data) => {
              const uniqueKey =
                isDepartmentBattle
                  ? `department-${data.companyDepartmentId ?? data.departmentName}`
                  : isTeamRankingLayout
                  ? `team-${data.meetWeTeamId}`
                  : `user-${data.nickName}`;

              return (
                <div key={uniqueKey} className="listContent">
                  <p className="center">{data.ranking}위</p>
                  <p className="leftalign">
                    {data.upDown === null || data.upDown === undefined || data.upDown === 0 ? (
                      "-"
                    ) : data.upDown > 0 ? (
                      <div style={{ display: "flex" }}>
                        <UpTriangle />
                        <p style={{ marginLeft: "4px" }}>{data.upDown}</p>
                      </div>
                    ) : (
                      <div style={{ display: "flex" }}>
                        <DownTriangle />
                        <p style={{ marginLeft: "4px" }}>{0 - data.upDown}</p>
                      </div>
                    )}
                  </p>
                  <p
                    className={
                      isDepartmentBattle ? "departmentNameCell" : "leftalign"
                    }
                  >
                    {isDepartmentBattle
                      ? data.departmentName
                      : isTeamRankingLayout
                      ? data.teamName
                      : data.nickName}
                  </p>
                  <p
                    className={
                      isDepartmentBattle ? "targetStepCell" : "leftalign"
                    }
                  >
                    {isDepartmentBattle ? (
                      <span>
                        {data.targetStep === null || data.targetStep === undefined
                          ? "-"
                          : `${Number(data.targetStep).toLocaleString()}걸음`}
                      </span>
                    ) : (
                      `${data.totalStep?.toLocaleString()}걸음`
                    )}
                  </p>
                  <p className="leftalign">
                    {isDepartmentBattle
                      ? data.progressPercent === null || data.progressPercent === undefined
                        ? "-"
                        : `${data.progressPercent}%`
                      : isTeamRankingLayout
                      ? data.memberCount?.toLocaleString() + "명"
                      : cCode_to_nation(data.cCode)}
                  </p>
                  {isOurContest && _ourContestType === "만보기(팀전)" ? (
                    <div className="center">
                      <div
                        className="blueBorderBtn-58x39 center"
                        style={{ marginRight: "2px" }}
                        onClick={() =>
                          onClickMemberRankings(
                            data.meetWeTeamId,
                            data.ranking,
                            data.teamName
                          )
                        }
                      >
                        랭킹
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              );
            })
          )}
        </ScrollArea>
      </Box>
    </div>
  );
};

const MemberRanking = ({ handleClickX, ranking, teamName, meetWeTeamId }) => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const getMemberRanking = async () => {
    try {
      let currentPage = 1;
      let body = { page: currentPage, offset: 20, meetWeTeamId };
      let res;
      let newList = [];
      do {
        res = await postJson(
          "/dashboard/meetWe/getRankingListTeamMember",
          body,
          navigate
        );
        newList = [...newList, ...res.data.rows];
        currentPage += 1;
        body.page = currentPage;
      } while (res.code === 200 && res.data.isNext === 1);
      setList(newList);
    } catch (error) {
      console.log("팀별 랭킹리스트 가져오기 중 에러");
      throw error;
    }
  };

  useEffect(() => {
    getMemberRanking();
  }, []);
  return (
    <BoxMemberRanking>
      <div className="hrz-wrapper center">
        <p className="bold-text" style={{ fontSize: "24px" }}>
          팀별 랭킹 간략히 보기
        </p>
      </div>
      <div className="hrz-wrapper" style={{ marginTop: "-32px" }}>
        <div style={{ marginLeft: "auto", cursor: "pointer" }}>
          <IconCrossRound onClick={handleClickX} />
        </div>
      </div>

      <div className="grayBox" style={{ margin: "20px 0" }}>
        <p className="medium-text" style={{ fontSize: "14px" }}>
          {ranking}위
        </p>
        <div style={{ height: "4px" }} />
        <p className="bold-text" style={{ fontSize: "18px", color: "#000000" }}>
          {teamName}
        </p>
      </div>

      <div className="listLabel">
        <p className="leftalign">닉네임</p>
        <p className="leftalign">누적 걸음 수</p>
        <p className="leftalign">국가</p>
      </div>

      <ScrollArea type="팀별 랭킹">
        {list.length === 0 ? (
          <div className="center" style={{ width: "100%", height: "100%" }}>
            <p style={{ fontSize: "15px", color: "#888888" }}>
              아직 참여 기록이 없습니다.
            </p>
          </div>
        ) : (
          list.map((data) => (
            <div className="listContent">
              <p className="leftalign">{data.nickName}</p>
              <p className="leftalign">
                {data.totalStep?.toLocaleString()}걸음
              </p>
              <p className="leftalign">{cCode_to_nation(data.cCode)}</p>
            </div>
          ))
        )}
      </ScrollArea>
    </BoxMemberRanking>
  );
};

const Box = styled.div`
  width: auto;
  height: auto;
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  .grayBox {
    margin: 20px 0;
    width: auto;
    height: auto;
    border-radius: 10px;
    background-color: #f5f5f5;
    padding: 18px 16px;
  }
  .listLabel {
    height: 44px;
    background-color: #f5f5f5;
    display: grid;
    grid-template-columns: ${(props) =>
      props.$isDepartmentBattle
        ? "80px 80px 225px 165px 100px"
        : `100px 80px 220px 200px 140px ${props.type === "만보기(팀전)" ? "58px" : ""}`};
    > p {
      font-family: "notoSans-medium";
      font-size: 14px;
      color: #888888;
      min-width: 0;
    }
  }
  .listContent {
    height: 56px;
    display: grid;
    grid-template-columns: ${(props) =>
      props.$isDepartmentBattle
        ? "80px 80px 225px 165px 100px"
        : `100px 80px 220px 200px 140px ${props.type === "만보기(팀전)" ? "58px" : ""}`};
    border-bottom: 1px solid #f0f0f0;
    > p {
      color: #000000;
      min-width: 0;
    }
  }

  .departmentNameCell {
    display: flex;
    align-items: center;
    margin: 0 0 0 14px;
    min-width: 0;
    word-break: break-all;
  }

  .targetStepCell {
    display: flex;
    align-items: center;
    margin: 0 0 0 14px;
    min-width: 0;
  }
`;

const BoxMemberRanking = styled.div`
  width: auto;
  height: auto;
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  position: absolute;
  margin: 30px;
  .listLabel {
    width: 740px;
    height: 44px;
    display: grid;
    grid-template-columns: 220px 200px 320px;
    background-color: #f5f5f5;
    font-family: "notoSans-medium";
    font-size: 14px;
    color: #888888;
  }
  .listContent {
    width: 740px;
    height: 56px;
    display: grid;
    grid-template-columns: 220px 200px 320px;
    > p {
      color: #000000;
    }
  }
`;

const TypeClickButton = styled.div`
  width: 124px;
  height: 39px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  cursor: pointer;
  background-color: ${(props) => (props.$isClicked ? "#1167ed" : "#ffffff")};
  color: ${(props) => (props.$isClicked ? "#ffffff" : "#1167ed")};
  ${(props) => (props.$isClicked ? "" : "box-shadow:inset 0 0 0 1px #1167ed")};
`;

const ScrollArea = styled.div`
  width: auto;
  height: ${(props) =>
    props.$isDepartmentBattle ? "360px" : props.type === "만보기(팀전)" ? "330px" : "392px"};
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 4px;
    z-index: 1;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #b0b0b0;
    border-radius: 20px;
  }
`;

const Rankings = ({
  title,
  infotext,
  contestType,
  contestTitle,
  contestPeriod,
  ourcontestType,
  handleClickX,
  id,
}) => {
  return (
    <LayoutModal
      Modal={
        <RankingsBox
          title={title}
          handleClickX={handleClickX}
          infotext={infotext}
          contestType={contestType}
          contestTitle={contestTitle}
          contestPeriod={contestPeriod}
          ourcontestType={ourcontestType}
          id={id}
        />
      }
    />
  );
};

export default Rankings;
